import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'
import { useLocation, Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { useFirebase } from '@scouts/auth'
import { media, Container, GlobalSpinner, Logo, Spacer } from '@taxfix/scouts-ui'

import { PATH_DASHBOARD } from '@/constants'

import { CompanyOfficerAuthLogin } from './CompanyOfficerAuthLogin'
import { CompanyOfficerAuthSignup } from './CompanyOfficerAuthSignup'

export const CompanyOfficerAuth = () => {
    const [route, setRoute] = useState<'signup' | 'login'>('signup')

    const { isInitialized, user } = useFirebase()
    const { search } = useLocation()

    const openSignup = () => setRoute('signup')
    const openLogin = () => setRoute('login')

    // @TODO: Remove referralSource logic if can be handled in the BE
    useEffect(() => {
        const queryParams = new URLSearchParams(search)
        const referralSource = queryParams.get('referralSource')
        const ONE_DAY_IN_MS = 1000 * 24 * 60 * 60
        const cookieSettings = { expires: new Date(Date.now() + 180 * ONE_DAY_IN_MS) }

        if (referralSource) Cookies.set('referralSource', referralSource, cookieSettings)
    }, [search])

    if (user) {
        return <Redirect to={PATH_DASHBOARD} />
    }

    return (
        <Container>
            <Wrapper>
                <Spacer width="100%" tabletWidth="504px">
                    <Container padding="24px">
                        <LogoWrapper>
                            <Logo />
                        </LogoWrapper>

                        {!isInitialized && <GlobalSpinner />}

                        {route === 'signup' && <CompanyOfficerAuthSignup onClickLogIn={openLogin} />}

                        {route === 'login' && <CompanyOfficerAuthLogin onClickSignUp={openSignup} />}
                    </Container>
                </Spacer>
            </Wrapper>
        </Container>
    )
}

const Wrapper = styled.div`
    display: flex;
    align-items: end;
    justify-content: center;
    min-height: 100vh;
    min-height: 100dvh;

    ${media.tablet} {
        align-items: center;
    }
`

const LogoWrapper = styled.div`
    display: none;
    width: 144px;
    margin: 0 auto 48px;

    ${media.tablet} {
        display: block;
    }
`
